// extracted by mini-css-extract-plugin
export default {"wrapper":"FloatingBar_wrapper__tdeXc","label":"FloatingBar_label__-qWHi","content":"FloatingBar_content__v-lxJ","closeButton":"FloatingBar_closeButton__+21OD"};